import { state } from "./state";
import { mutations } from "./mutations";
import { getters } from "./getters";
import { actions } from "./actions";

const azJobApplicantsModule = {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}

export default azJobApplicantsModule